var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "39px",
    viewBox: "0 0 54 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u71C3\u6599") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.5489271%",
    y1: "23.9197531%",
    x2: "40.7563079%",
    y2: "40.9976106%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B3E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4E64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E2FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875-\\u6B63\\u5F0F",
    transform: "translate(-26.000000, -293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u71C3\\u6599",
    transform: "translate(26.000000, 293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-21\\u5907\\u4EFD-2",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    shapeRendering: "geometricPrecision",
    d: "M22.3477493,0.275 L31.7764552,0.275 L53.6381348,30.7144808 L45.3639798,38.725 L4.76670584,38.725 L0.325512028,30.7658979 L22.3477493,0.275 Z",
    id: "\\u8DEF\\u5F84-10",
    fill: "url(#linearGradient-1)",
    transform: "translate(27.000000, 19.500000) scale(1, -1) translate(-27.000000, -19.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    shapeRendering: "geometricPrecision",
    d: "M22.3477493,0.275 L31.7764552,0.275 L53.6381348,30.7144808 L45.3639798,38.725 L4.76670584,38.725 L0.325512028,30.7658979 L22.3477493,0.275 Z",
    id: "\\u8DEF\\u5F84-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_\\u71C3\\u6599\\u52A0\\u6CE8",
    transform: "translate(18.734694, 11.142857)"
  }, /*#__PURE__*/React.createElement("rect", {
    shapeRendering: "geometricPrecision",
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 17.6326531,
    height: 17.8285714
  }), /*#__PURE__*/React.createElement("path", {
    shapeRendering: "geometricPrecision",
    d: "M12.2546939,10.4965714 C9.85665306,10.4965714 7.88620408,8.88308571 7.88620408,6.92194286 C7.84653061,6.76148571 7.83771429,5.54914286 9.30122449,3.00857143 L8.17273469,1.97897143 L8.17273469,0.953828571 L8.41518367,0.953828571 C8.69289796,0.953828571 8.93534694,0.730971429 8.93534694,0.476914286 C8.9397551,0.222857143 8.73257143,0 8.41959184,0 L3.90122449,0 C3.6235102,0 3.38106122,0.222857143 3.38106122,0.476914286 C3.38106122,0.730971429 3.6235102,0.953828571 3.90122449,0.953828571 L4.07314286,0.953828571 L4.07314286,1.84525714 L2.44212245,1.84525714 C1.92195918,1.84525714 1.50318367,2.22857143 1.50318367,2.70548571 L1.50318367,16.9683429 C1.50318367,17.4452571 1.92195918,17.8285714 2.44212245,17.8285714 L13.2906122,17.7037714 C13.8107755,17.7037714 14.229551,17.3204571 14.229551,16.8435429 L14.229551,10.1088 C13.6168163,10.3584 12.933551,10.4965714 12.2546939,10.4965714 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    strokeWidth: 0.77,
    strokeDasharray: 0.7699999868869782
  }), /*#__PURE__*/React.createElement("path", {
    shapeRendering: "geometricPrecision",
    d: "M16.1162449,6.43611429 C15.9090612,4.1184 13.3214694,0.913714286 13.2421224,0.775542857 L12.6999184,0.129257143 L12.2017959,0.8112 C9.28359184,4.59531429 9.28359184,6.29794286 9.32767347,6.47177143 C9.32767347,8.00502857 10.8705306,9.2664 12.744,9.2664 C13.7005714,9.2664 14.661551,8.92765714 15.2875102,8.34377143 C15.9090612,7.80445714 16.2,7.11805714 16.1162449,6.43611429 L16.1162449,6.43611429 Z M14.5293061,5.93245714 L13.176,5.93245714 L13.176,7.3008 C13.1715918,7.5504 12.9688163,7.75097143 12.7219592,7.75097143 C12.475102,7.75097143 12.2723265,7.5504 12.2679184,7.3008 L12.2679184,5.93691429 L10.9234286,5.93691429 C10.6721633,5.93691429 10.4693878,5.73188571 10.4693878,5.47782857 C10.4693878,5.22377143 10.6721633,5.01874286 10.9234286,5.01874286 L12.2679184,5.01874286 L12.2679184,3.66377143 C12.2679184,3.40971429 12.4706939,3.20468571 12.7219592,3.20468571 C12.9732245,3.20468571 13.176,3.40971429 13.176,3.66377143 L13.176,5.00982857 L14.5293061,5.00982857 C14.7761633,5.01428571 14.9745306,5.21931429 14.9745306,5.46891429 C14.9745306,5.72297143 14.7761633,5.928 14.5293061,5.93245714 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.a362e6c801af22b516cda1c2c04fbde4.svg";
export { ForwardRef as ReactComponent };